import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { TrackingList } from '@/components/company/tracking/table-view';

const companyTrackingSearchSchema = z.object({
  date: z.string().optional(),
  branchId: z.string().optional(),
});

export const Route = createFileRoute('/(app)/company/tracking/')({
  component: TrackingRoute,
  validateSearch: companyTrackingSearchSchema,
});

function TrackingRoute() {
  return <TrackingList />;
}
